/* src/app/views/choose-plan/choose-plan.component.scss */
.chose-plan-page-title {
  font-weight: normal;
  font-style: normal;
  font-size: 36pt;
  line-height: 50px;
  color: #000000;
  padding: 0;
}
.chose-plan-page-title-position {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  float: none;
  padding: 18px 0 8px;
}
.chose-plan-title {
  font-weight: normal;
  font-style: normal;
  font-size: 36px;
  line-height: 1.2;
  color: #000000;
  padding: 8px 0 0;
}
.chose-plan-title2 {
  font-weight: normal;
  font-style: normal;
  font-size: 16px;
  line-height: 1.35;
  color: #002f6c;
  padding: 0;
}
.chose-plan-image_start {
  width: 84px;
  height: auto;
  flex: 0 0 auto;
}
.chose-plan-span_start {
  margin-top: 0;
}
.chose-plan-span_bold {
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 1.25;
  color: #000000;
}
.chose-plan-apply_margin_left {
  margin-left: 10%;
  margin-bottom: 5px;
}
.chose-plan-apply_margin_bottom {
  margin-bottom: 3%;
}
.chose-plan-plus-span {
  font-style: normal;
  font-weight: bold;
  font-size: 36px;
  line-height: 1;
  color: #000000;
  display: inline-block;
}
.chose-plan-button-plan {
  width: 207px;
  height: 207px;
  background: #ffffff;
  border: 1px solid #dfe0de;
  box-sizing: border-box;
  box-shadow: 0px 3px 8px rgba(15, 23, 42, 0.12);
  border-radius: 10px;
  font-family: Ford Antenna Cond;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 1.25;
  text-align: center;
  color: #002f6c;
  cursor: pointer;
  padding: 16px;
}
.chose-plan-button-plan:hover {
  background-color: #0276be;
  color: #ffffff;
  text-align: center;
}
.chose-plan-button-plan:focus {
  background-color: #0276be;
  color: #ffffff;
  text-align: center !important;
}
.chose-plan-button-plan-selected {
  background-color: #0276be;
  color: #ffffff;
  text-align: center !important;
}
.chose-plan-button-plan:disabled {
  background-color: #E5E5E5;
  color: #202020;
  cursor: not-allowed;
  border: 1px solid #aaaaaa;
  opacity: 0.7;
}
.chose-plan-icon {
  font-size: 4rem;
  margin-right: auto;
}
.chose-plan-span-value {
  text-align: center;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  color: #307b41;
  margin-top: 10px;
}
.chose-plan-span-sub-total {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  color: #002f6c;
}
.chose-plan-span-total {
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #636363;
}
.chose-plan-card {
  margin-top: 3px;
  margin-bottom: 3px;
}
.chose-plan-hero-block {
  margin-bottom: 4px;
  margin-top: 0;
  padding: 26px 30px 20px;
  border: 1px solid #a8d8ac;
  border-radius: 14px;
  background: #dae6dc;
  z-index: 0;
}
.chose-plan-hero-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
}
.chose-plan-hero-head-icon {
  color: #008e12;
  font-size: 22px;
}
.chose-plan-hero-head-title {
  font-size: 20px;
  line-height: 1.15;
  font-weight: 700;
  padding: 0;
}
.chose-plan-hero-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 56px;
  width: fit-content;
  max-width: 100%;
  margin: 0 auto;
  padding: 2px 0 4px;
}
.chose-plan-hero-item {
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;
  max-width: 100%;
  flex: 0 0 auto;
}
.chose-plan-hero-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.chose-plan-hero-icon-wrap {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #cfe3cf;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}
.chose-plan-hero-benefit-icon {
  font-size: 34px;
  color: #008e12;
}
.chose-plan-hero-item-subtitle {
  font-size: 14px;
  line-height: 1.25;
  font-weight: 400;
  color: #7f8b96;
}
.chose-plan-plus-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
}
.chose-plan-hero-plan-title {
  margin-top: 14px;
}
.chose-plan-hero-notes {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  margin-top: 22px;
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  padding-left: 45px;
  box-sizing: border-box;
}
.chose-plan-hero-note-item {
  font-size: 14px;
  line-height: 1.25;
  font-weight: 400;
  color: #7f8b96;
  text-align: left;
}
@media (max-width: 980px) {
  .chose-plan-page-title {
    font-size: clamp(2rem, 2.7vw, 3rem);
    line-height: 1.15;
  }
  .chose-plan-hero-head-title {
    font-size: 18px;
  }
  .chose-plan-span_bold {
    font-size: 17px;
  }
  .chose-plan-hero-item-subtitle {
    font-size: 14px;
  }
  .chose-plan-title {
    font-size: 30px;
  }
  .chose-plan-hero-row {
    flex-direction: column;
    gap: 18px;
    align-items: flex-start;
  }
  .chose-plan-hero-item {
    min-width: 0;
    width: 100%;
  }
  .chose-plan-hero-notes {
    width: 100%;
    padding-left: 0;
  }
  .chose-plan-plus-wrap {
    width: 100%;
    justify-content: flex-start;
  }
}
.choose-plan-page-header {
  width: calc(100% - 64px);
  max-width: calc(100% - 64px);
  margin: 0 auto 16px;
  position: relative;
  box-sizing: border-box;
}
.chose-plan-layout-panel {
  width: calc(100% - 64px);
  max-width: calc(100% - 64px);
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  margin-left: 0 !important;
  margin-right: 0 !important;
  box-sizing: border-box;
}
:host .container.chose-plan > .container-body > .chose-plan-layout-panel {
  width: calc(100% - 64px) !important;
  max-width: calc(100% - 64px) !important;
  flex: 0 0 calc(100% - 64px) !important;
  align-self: center !important;
  left: 50% !important;
  transform: translateX(-50%);
  margin-left: 0 !important;
  margin-right: 0 !important;
  box-sizing: border-box;
}
.chose-plan-layout-panel.grid {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.container-body > .chose-plan-layout-panel {
  margin-top: 12px;
}
.container-body > .choose-plan-page-header + .chose-plan-layout-panel {
  margin-top: 0;
}
.chose-plan-hero-block {
  display: flex;
  flex-direction: column;
}
.chose-plan-hero-head {
  width: 100%;
  justify-content: flex-start;
}
.chose-plan-section-box {
  width: calc(100% - 56px);
  margin-left: 28px !important;
  margin-right: 28px !important;
  box-sizing: border-box;
}
.chose-plan-section-box.grid {
  margin-left: 28px !important;
  margin-right: 28px !important;
}
.container-body > .chose-plan-section-box {
  margin-top: 12px;
}
.container-body > .choose-plan-page-header + .chose-plan-section-box {
  margin-top: 16px;
}
:host ::ng-deep .table {
  font-family: Ford Antenna !important;
  font-style: normal !important;
  font-weight: bold !important;
  font-size: 14px !important;
  line-height: 20px !important;
  color: #000000 !important;
  border-color: #ffffff !important;
  background-color: #ffffff !important;
  text-align: left !important;
  padding: 0.571em 0.5em !important;
}
:host ::ng-deep .table-text-style {
  color: #000000;
  font-size: 10pt;
}
:host ::ng-deep .table-a-style {
  color: #0078d7;
  font-weight: normal;
}
:host ::ng-deep .table-a-style:hover {
  color: #0062af;
}
:host ::ng-deep .center {
  text-align: center !important;
}
:host ::ng-deep .ui-table table {
  table-layout: unset !important;
}
:host ::ng-deep .ui-table-tbody tr {
  height: 40px;
}
.input-edit {
  width: 150px;
  height: 30px;
  background: #ffffff;
  border: 1px solid #4d4d4d;
  border-radius: 3px;
  font-size: 12pt;
  color: #333333;
  margin-bottom: 4px;
}
.input-edit:focus {
  outline: none;
  border-color: #046cea;
  box-shadow: 0 0 5px rgba(4, 110, 234, 0.5);
}
.input-edit-invalid {
  border-color: #dc2626;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.15);
}
.choose-plan-price-hint {
  display: inline-block;
  margin-top: 6px;
  font-size: 12px;
  line-height: 1.3;
  font-weight: 500;
  color: #455b78;
}
.choose-plan-price-hint-invalid {
  color: #b42318;
}
.btn-cursor {
  cursor: pointer;
}
.position-of-editable-items {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.icon-edit {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 136px;
}
.btn-action-icon {
  font-size: 14px;
}
.btn-edit-save {
  min-width: 106px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 12px;
  background: #046cea;
  border: 1px solid #046cea;
  border-radius: 10px;
  cursor: pointer;
}
.btn-edit-save-span {
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
}
.btn-edit-save .btn-action-icon {
  color: #ffffff;
}
.btn-edit-save:disabled {
  background-color: #e5e5e5;
  border: 1px solid #aaaaaa;
  cursor: not-allowed;
  opacity: 0.8;
}
.btn-edit-save:disabled .btn-edit-save-span {
  color: #202020;
}
.btn-edit-save:disabled .btn-action-icon {
  color: #202020;
}
.btn-edit-save:hover:not(:disabled) {
  background: #044ea7;
}
.btn-cancel {
  min-width: 106px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 12px;
  background: #ffffff;
  border: 1px solid #046cea;
  border-radius: 10px;
  margin-right: 0;
  cursor: pointer;
}
.btn-cancel-span {
  font-size: 14px;
  font-weight: 500;
  color: #046cea;
}
.btn-cancel .btn-action-icon {
  color: #046cea;
}
.btn-cancel:disabled {
  background-color: #f2f2f2;
  border: 1px solid #aaaaaa;
  cursor: not-allowed;
}
.btn-cancel:disabled .btn-cancel-span {
  color: #7a7a7a;
}
.btn-cancel:disabled .btn-action-icon {
  color: #7a7a7a;
}
.btn-cancel:hover:not(:disabled) {
  background: #044ea7;
}
button.btn-cancel:hover:not(:disabled) .btn-cancel-span {
  color: #ffffff;
}
button.btn-cancel:hover:not(:disabled) .btn-action-icon {
  color: #ffffff;
}
.chose-plan-apply_margin_bottom {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin-bottom: 0;
  padding: 12px 0;
}
.chose-plan-cards-wrap {
  width: 100%;
}
.chose-plan-total-list {
  margin-top: 12px;
  padding: 12px 14px;
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  background: #ffffff;
  position: relative;
  z-index: 1;
}
.chose-plan-total-divider {
  border: 0;
  border-top: 1px solid #d9d9d9;
  margin: 14px 0 10px;
}
.chose-plan-total-row {
  padding-right: 8px;
  margin-bottom: 4px;
}
:host ::ng-deep .chose-plan-card .p-card {
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  box-shadow: none;
  background: #ffffff;
  width: 100%;
}
:host ::ng-deep .chose-plan-card p-card {
  display: block;
  width: 100%;
}
:host ::ng-deep .chose-plan-card .p-card .p-card-body {
  padding: 14px 16px;
}
.chose-plan-db-details {
  display: block;
  margin-top: 6px;
}
:host ::ng-deep .chose-plan-db-details,
:host ::ng-deep .chose-plan-db-details p,
:host ::ng-deep .chose-plan-db-details span,
:host ::ng-deep .chose-plan-db-details li {
  font-size: 15px;
  line-height: 1.35;
  font-weight: 400;
  color: #6b7280;
  text-transform: none;
  letter-spacing: normal;
  margin: 0 0 12px;
}
:host ::ng-deep .chose-plan-db-details ul,
:host ::ng-deep .chose-plan-db-details ol {
  margin: 0 0 12px 18px;
  padding: 0;
}
:host ::ng-deep .chose-plan-db-details strong,
:host ::ng-deep .chose-plan-db-details b {
  font-weight: 500;
  color: #1f2937;
}
.chose-plan-cards-row {
  width: min(1180px, 100%);
  max-width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(3, minmax(220px, 1fr));
  gap: 24px;
  align-items: center;
}
.chose-plan-card-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.chose-plan-price-row {
  width: 100%;
  margin-top: 4px;
}
.chose-plan-button-plan {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0;
}
.chose-plan-button-plan-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 12px;
  width: 100%;
}
.chose-plan-button-plan-label {
  display: block;
  max-width: 100%;
  font-size: 18px;
  line-height: 1.25;
  font-weight: 700;
  word-break: break-word;
}
.chose-plan-button-plan .chose-plan-icon {
  font-size: 3.4rem;
  text-align: center;
  margin: 0;
  padding: 0;
}
@media (max-width: 1100px) {
  .chose-plan-cards-row {
    grid-template-columns: repeat(2, minmax(220px, 1fr));
  }
}
@media (max-width: 760px) {
  .chose-plan-cards-row {
    grid-template-columns: 1fr;
    gap: 14px;
  }
  .chose-plan-button-plan {
    width: 100%;
    min-height: 144px;
  }
}
.table-position {
  margin-top: 0;
}
.renewal-interest-link {
  background: none;
  border: none;
  padding: 0;
  color: var(--primary-color, #006cb7);
  font-size: 12px;
  text-decoration: underline;
  cursor: pointer;
  white-space: nowrap;
}
.renewal-interest-registered {
  font-size: 12px;
  color: #6c757d;
  white-space: nowrap;
}
.chose-plan-summary {
  width: calc(100% - 56px);
  margin: 8px 28px 0;
  padding: 6px 0 0;
  box-sizing: border-box;
}
.chose-plan-summary-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 18px;
  padding: 8px 0;
  text-align: left;
}
.chose-plan-summary-item span:last-child {
  white-space: nowrap;
  color: #4a525a;
}
.chose-plan-total-row {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: baseline;
  gap: 6px;
  margin-right: 20px;
  padding: 0 0 4px;
}
.chose-plan-total-label {
  font-size: 18px;
  line-height: 1.35;
  font-weight: 500;
  color: #0f172a;
}
.chose-plan-total-value {
  font-size: 18px;
  line-height: 1.35;
  font-weight: 500;
  color: #6b7280;
}
.button-position {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  width: calc(100% - 56px);
  margin: 20px 28px 0;
  padding-top: 18px;
  border-top: 1px solid #d9d9d9;
  box-sizing: border-box;
}
.action-button {
  width: 137px;
  height: 48px;
  background: #046cea;
  border: 1px solid #046cea;
  border-radius: 10px;
  margin-top: 0;
  margin-right: 0;
}
.action-button-span {
  font-size: 15pt;
  font-weight: 500;
  color: #ffffff;
}
.action-button:disabled {
  background-color: #e5e5e5;
  cursor: not-allowed;
  border: 1px solid #aaaaaa;
  opacity: 0.7;
}
.action-button:disabled .action-button-span {
  color: #202020;
}
.action-button:hover:not(:disabled) {
  background: #044ea7;
}
.action-button:disabled:hover {
  background-color: #e5e5e5;
  color: #202020;
  cursor: not-allowed;
  border: 1px solid #aaaaaa;
}
.action-button:disabled:hover .action-button-span {
  color: #202020;
}
.undo-action-button {
  background: #ffffff;
  border: 1px solid #046cea;
  border-radius: 10px;
  margin-top: 0;
  margin-right: 0;
}
.undo-action-button-span {
  font-size: 15pt;
  font-weight: 500;
  color: #046cea;
  margin-left: 5px;
}
.clear {
  width: 250px;
  height: 48px;
}
.return {
  width: 137px;
  height: 48px;
}
.undo-action-button:hover {
  background: #044ea7;
}
button.undo-action-button:hover .undo-action-button-span {
  color: #ffffff;
}
@media (max-width: 768px) {
  .choose-plan-page-header {
    width: calc(100% - 48px);
    max-width: calc(100% - 48px);
  }
  .chose-plan-hero-block {
    padding: 16px 16px 14px;
  }
  .chose-plan-hero-head {
    margin-bottom: 12px;
  }
  .chose-plan-hero-head-icon {
    font-size: 24px;
  }
  .chose-plan-hero-head-title {
    font-size: 17px;
  }
  .chose-plan-span_bold {
    font-size: 16px;
  }
  .chose-plan-hero-item-subtitle {
    font-size: 13px;
  }
  .chose-plan-page-title {
    font-size: 2rem;
    line-height: 1.15;
  }
  .chose-plan-page-title-position {
    padding: 18px 16px 8px;
  }
  .chose-plan-layout-panel {
    width: calc(100% - 48px);
    max-width: calc(100% - 48px);
    left: 50%;
    transform: translateX(-50%);
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  :host .container.chose-plan > .container-body > .chose-plan-layout-panel {
    width: calc(100% - 48px) !important;
    max-width: calc(100% - 48px) !important;
    flex: 0 0 calc(100% - 48px) !important;
    align-self: center !important;
    left: 50% !important;
    transform: translateX(-50%);
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .chose-plan-layout-panel.grid {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .chose-plan-section-box {
    width: calc(100% - 32px);
    margin-left: 16px !important;
    margin-right: 16px !important;
  }
  .chose-plan-section-box.grid {
    margin-left: 16px !important;
    margin-right: 16px !important;
  }
  .chose-plan-summary {
    width: calc(100% - 32px);
    margin: 8px 16px 0;
  }
  .chose-plan-summary-item {
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
  }
}
:host ::ng-deep .table-plan-name {
  width: 410px !important;
  min-width: 410px !important;
}
:host {
  --choose-bg: #ffffff;
  --choose-panel: #ffffff;
  --choose-border: #d8e0ea;
  --choose-border-strong: #b7c5d6;
  --choose-text: #101928;
  --choose-muted: #667085;
  --choose-primary: #005aa9;
  --choose-primary-hover: #004687;
  --choose-shadow-soft: 0 8px 24px rgba(16, 24, 40, 0.08);
  --choose-shadow-card: 0 10px 22px rgba(7, 26, 57, 0.14);
}
@keyframes choosePlanFadeSlideUp {
  from {
    opacity: 0;
    filter: blur(1px);
  }
  to {
    opacity: 1;
    filter: blur(0);
  }
}
@keyframes choosePlanPulseSelect {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.08);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes choosePlanGlowSweep {
  0% {
    opacity: 0;
    transform: translateX(-30%);
  }
  50% {
    opacity: 0.9;
  }
  100% {
    opacity: 0;
    transform: translateX(160%);
  }
}
.container.chose-plan {
  background: var(--choose-bg);
  min-height: 100%;
  padding-bottom: 18px;
}
.chose-plan-animate-in {
  opacity: 0;
  animation: choosePlanFadeSlideUp 420ms cubic-bezier(0.2, 0.8, 0.2, 1) forwards;
  will-change: opacity, filter;
}
.chose-plan-animate-delay-1 {
  animation-delay: 30ms;
}
.chose-plan-animate-delay-2 {
  animation-delay: 90ms;
}
.chose-plan-animate-delay-3 {
  animation-delay: 150ms;
}
.chose-plan-animate-delay-4 {
  animation-delay: 210ms;
}
.chose-plan-animate-delay-5 {
  animation-delay: 260ms;
}
.chose-plan-animate-delay-6 {
  animation-delay: 320ms;
}
.choose-plan-page-header {
  padding: 4px 0 0;
}
.chose-plan-page-title {
  font-weight: 700;
  letter-spacing: 0.2px;
  color: var(--choose-text);
  text-wrap: balance;
}
.chose-plan-layout-panel,
.chose-plan-section-box,
.chose-plan-summary {
  background: var(--choose-panel);
  border: 1px solid var(--choose-border);
  border-radius: 14px;
  box-shadow: var(--choose-shadow-soft);
  overflow: hidden;
}
.chose-plan-layout-panel-hero {
  border-color: #bbdec2;
  box-shadow: 0 10px 22px rgba(56, 120, 74, 0.15);
}
.chose-plan-layout-panel-options,
.chose-plan-layout-panel-table {
  padding-top: 10px;
  padding-bottom: 10px;
}
.chose-plan-total-list {
  border: 0;
  background: transparent;
  padding: 8px 14px 2px;
  box-shadow: none;
}
.chose-plan-loading-status {
  margin: 6px 0 10px;
}
.chose-plan-loading-panel {
  width: 100%;
  border: 1px solid #bed2e9;
  border-radius: 12px;
  padding: 14px 16px 12px;
  background: #ffffff;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);
}
.chose-plan-loading-head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.chose-plan-loading-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #dbeafc;
  color: #12528f;
  font-size: 16px;
  flex: 0 0 auto;
}
.chose-plan-loading-copy {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}
.chose-plan-loading-title {
  font-size: 15px;
  line-height: 1.3;
  font-weight: 600;
  color: #1a3557;
}
.chose-plan-loading-subtitle {
  font-size: 13px;
  line-height: 1.35;
  font-weight: 400;
  color: #47678b;
}
.chose-plan-loading-track {
  margin-top: 11px;
  width: 100%;
  height: 7px;
  border-radius: 999px;
  background: #d7e5f5;
  overflow: hidden;
  position: relative;
}
.chose-plan-loading-bar {
  display: block;
  height: 100%;
  width: 38%;
  border-radius: 999px;
  background:
    linear-gradient(
      90deg,
      #2e7cbc 0%,
      #4ca3e6 60%,
      #2e7cbc 100%);
  animation: choosePlanLoadingSlide 1.2s ease-in-out infinite;
}
@keyframes choosePlanLoadingSlide {
  0% {
    transform: translateX(-120%);
  }
  50% {
    transform: translateX(80%);
  }
  100% {
    transform: translateX(260%);
  }
}
.chose-plan-cards-row {
  gap: 18px;
}
.chose-plan-card-col {
  width: 100%;
}
.chose-plan-button-plan {
  width: 100%;
  max-width: 280px;
  min-height: 186px;
  height: auto;
  border: 1px solid var(--choose-border);
  border-radius: 14px;
  box-shadow: var(--choose-shadow-card);
  transition:
    transform 0.22s ease,
    box-shadow 0.22s ease,
    background-color 0.22s ease,
    border-color 0.22s ease;
}
.chose-plan-button-plan:hover:not(:disabled),
.chose-plan-button-plan:focus-visible:not(:disabled) {
  transform: translateY(-3px);
  border-color: #2c82cf;
  box-shadow: 0 12px 26px rgba(7, 34, 73, 0.2);
}
.chose-plan-button-plan-selected {
  border-color: #1f77c2;
  box-shadow: 0 12px 28px rgba(7, 41, 82, 0.24);
  position: relative;
  overflow: hidden;
}
.chose-plan-button-plan-selected::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 34%;
  height: 100%;
  background:
    linear-gradient(
      100deg,
      rgba(255, 255, 255, 0.08),
      rgba(255, 255, 255, 0.35),
      rgba(255, 255, 255, 0.08));
  pointer-events: none;
  animation: choosePlanGlowSweep 640ms ease-out;
}
.chose-plan-button-plan-selected .chose-plan-icon {
  animation: choosePlanPulseSelect 320ms ease-out;
}
.chose-plan-button-plan:focus-visible {
  outline: 2px solid #6db4ec;
  outline-offset: 2px;
}
.chose-plan-button-plan-label {
  font-size: 20px;
  line-height: 1.15;
  text-wrap: balance;
}
.chose-plan-price-row {
  margin-top: 8px;
  min-height: 28px;
}
.chose-plan-span-value {
  font-weight: 700;
  font-size: 15px;
  color: #1f7a34;
}
:host ::ng-deep .p-table {
  border-radius: 12px;
  overflow: clip;
  border: 1px solid var(--choose-border);
  box-shadow: none;
  background: #fff;
}
:host ::ng-deep .p-table .p-datatable-thead > tr > th {
  background: #eef3f8 !important;
  border-color: #d2dce8 !important;
  color: #1c2f46 !important;
  font-size: 13px !important;
  text-transform: uppercase;
  letter-spacing: 0.35px;
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}
:host ::ng-deep .p-table .p-datatable-tbody > tr > td {
  border-color: #e6edf5 !important;
  padding-top: 14px !important;
  padding-bottom: 14px !important;
  vertical-align: middle;
  transition: background-color 0.18s ease;
}
:host ::ng-deep .p-table .p-datatable-tbody > tr:nth-child(even) {
  background: #fbfdff;
}
:host ::ng-deep .p-table .p-datatable-tbody > tr:hover {
  background: #f3f8fe;
}
.chose-plan-summary {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 10px 18px;
  margin-top: 14px;
  border-color: #c8d7ea;
  background: #ffffff;
}
.chose-plan-total-divider {
  margin-top: 6px;
  margin-bottom: 10px;
  border-top-color: #d5e0ee;
}
.chose-plan-total-row {
  margin-top: 0;
  margin-right: 0;
  padding-bottom: 0;
}
.chose-plan-total-label {
  font-size: 18px;
  font-weight: 600;
  color: #20324a;
}
.chose-plan-total-value {
  font-size: 24px;
  font-weight: 700;
  color: #0f4e8b;
  line-height: 1;
}
.button-position {
  position: sticky;
  bottom: 0;
  z-index: 4;
  padding: 14px 0 6px;
  margin-top: 14px;
  background: #ffffff;
  backdrop-filter: blur(2px);
  border-top: 0;
}
.action-button,
.undo-action-button,
.btn-edit-save,
.btn-cancel {
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease;
  box-shadow: 0 6px 14px rgba(5, 31, 66, 0.14);
}
.action-button:focus-visible,
.undo-action-button:focus-visible,
.btn-edit-save:focus-visible,
.btn-cancel:focus-visible {
  outline: 2px solid #6db4ec;
  outline-offset: 2px;
}
.action-button:hover:not(:disabled),
.undo-action-button:hover:not(:disabled),
.btn-edit-save:hover:not(:disabled),
.btn-cancel:hover:not(:disabled) {
  transform: translateY(-1px);
}
.action-button {
  background: var(--choose-primary);
  border-color: var(--choose-primary);
}
.action-button:hover:not(:disabled) {
  background: var(--choose-primary-hover);
  border-color: var(--choose-primary-hover);
}
.undo-action-button {
  border-color: var(--choose-primary);
}
.chose-plan-db-details,
:host ::ng-deep .chose-plan-db-details p,
:host ::ng-deep .chose-plan-db-details span,
:host ::ng-deep .chose-plan-db-details li {
  color: var(--choose-muted);
  line-height: 1.5;
}
@media (max-width: 980px) {
  .chose-plan-layout-panel,
  .chose-plan-section-box,
  .chose-plan-summary {
    border-radius: 12px;
  }
  .chose-plan-button-plan {
    max-width: none;
    min-height: 156px;
  }
  .chose-plan-button-plan-label {
    font-size: 18px;
  }
  .chose-plan-total-value {
    font-size: 22px;
  }
}
@media (max-width: 768px) {
  .chose-plan-animate-in {
    animation-duration: 300ms;
  }
  .button-position {
    position: static;
    padding-top: 10px;
    background: transparent;
    backdrop-filter: none;
  }
  .chose-plan-total-row {
    justify-content: flex-start;
    gap: 10px;
  }
  .chose-plan-total-label {
    font-size: 16px;
  }
  .chose-plan-total-value {
    font-size: 21px;
  }
  :host ::ng-deep .p-table .p-datatable-thead > tr > th,
  :host ::ng-deep .p-table .p-datatable-tbody > tr > td {
    font-size: 12px !important;
  }
}
@media (prefers-reduced-motion: reduce) {
  .chose-plan-animate-in,
  .chose-plan-button-plan-selected .chose-plan-icon,
  .chose-plan-button-plan-selected::after {
    animation: none !important;
    opacity: 1;
    filter: none;
  }
  .chose-plan-button-plan,
  .action-button,
  .undo-action-button,
  .btn-edit-save,
  .btn-cancel {
    transition: none !important;
  }
}
/*# sourceMappingURL=choose-plan.component-5RSK5AWU.css.map */
